import isObjectLike from "lodash/isObjectLike"

class Model {
  constructor(props) {
    Object.assign(this, props)
  }
}

Model.isModel = function isModel(object) {
  return isObjectLike(object) && object instanceof Model
}

Model.clone = function clone(source, properties) {
  return new Model({
    ...source,
    ...properties,
  })
}

export default Model
